<interview-wrapper [title]="'interviews.Welcome Title' | translate">
    <div step-content>
        <p class="welcome body">
            {{'interviews.Welcome Text' | translate}}
        </p>
    </div>
  
    <div step-actions>
        <button type="button" [routerLink]="['settings']" class="btn btn_primary">{{'interviews.Continue' | translate}}</button>
    </div>
</interview-wrapper>